import { useCallback, useEffect, useState } from "react";
import { Check, Star, X } from "lucide-react";
import { adminApi, errText } from "./adminApi";

export default function AdminReviews() {
  const [reviews, setReviews] = useState(null);
  const [counts, setCounts] = useState({});
  const [filter, setFilter] = useState("pending");
  const [error, setError] = useState("");

  const load = useCallback(() => {
    adminApi.get("/admin/reviews", { params: { status: filter } })
      .then(({ data }) => { setReviews(data.reviews); setCounts(data.counts); })
      .catch((e) => setError(errText(e)));
  }, [filter]);
  useEffect(load, [load]);

  const act = async (id, action) => {
    try {
      await adminApi.post(`/admin/reviews/${id}/${action}`);
      load();
    } catch (e) { setError(errText(e)); }
  };

  return (
    <div className="admin-card" data-testid="admin-reviews">
      <div className="admin-row" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
        <div>
          <h3 style={{ margin: 0 }}>Student Reviews</h3>
          <p className="lead-sub" style={{ margin: "4px 0 0" }}>Students write reviews in their portal. Read them here — only ones you approve appear on the live site.</p>
        </div>
        <div className="admin-row">
          {[["pending", `Pending (${counts.pending ?? 0})`], ["approved", `Approved (${counts.approved ?? 0})`], ["rejected", `Rejected (${counts.rejected ?? 0})`]].map(([key, label]) => (
            <button key={key} className={`admin-btn ${filter === key ? "primary" : ""}`} onClick={() => setFilter(key)} data-testid={`reviews-filter-${key}`}>{label}</button>
          ))}
        </div>
      </div>
      {error && <p className="lead-note err" data-testid="reviews-error">{error}</p>}
      {!reviews ? <p className="admin-empty">Loading…</p> : reviews.length === 0 ? (
        <p className="admin-empty" data-testid="reviews-empty">No {filter} reviews.</p>
      ) : reviews.map((r, i) => (
        <div key={r.review_id} style={{ borderTop: "1px solid rgba(255,255,255,.08)", padding: "14px 0" }} data-testid={`review-row-${i}`}>
          <div className="admin-row" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
            <span>
              <b>{r.name}</b> <span style={{ color: "#9db1c9", fontSize: 12 }}>{r.meta}</span>
              <span style={{ marginLeft: 10, color: "#f7b500" }} data-testid={`review-rating-${i}`}>
                {"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}
              </span>
            </span>
            <span className="admin-row">
              {r.status !== "approved" && (
                <button className="admin-btn" style={{ background: "#15803d" }} onClick={() => act(r.review_id, "approve")} data-testid={`review-approve-${i}`}><Check size={14} /> Approve</button>
              )}
              {r.status !== "rejected" && (
                <button className="admin-btn" style={{ background: "#7f1d1d" }} onClick={() => act(r.review_id, "reject")} data-testid={`review-reject-${i}`}><X size={14} /> Reject</button>
              )}
            </span>
          </div>
          <p style={{ margin: "8px 0 0", color: "#c9d6e8", fontSize: 14, lineHeight: 1.6 }} data-testid={`review-text-${i}`}>{r.text}</p>
        </div>
      ))}
      {reviews && reviews.some((r) => r.status === "pending") && (
        <p className="lead-note" style={{ marginTop: 10 }}><Star size={12} style={{ verticalAlign: "-2px" }} /> Approved reviews go live on the homepage instantly — no deploy needed.</p>
      )}
    </div>
  );
}
